import store from '@/store'
import D2C_Provider from '../Provider'

class D2C_ProviderHosting extends D2C_Provider {
  purpose = 'hosting'
  static objectType = 'providerPurpose'
  static purposeName = 'hosting'
  static purposeTitle = 'Hosting'
  static get _instances() {
    return store.getters.instances.filter(instance => instance.providerType === this.providerType)
  }
  static get _regions() {
    return store.getters.regions.filter(region => region.providerType === this.providerType)
  }
  static get _hosts() {
    return store.getters.hosts.filter(host => host.constructor.providerType === this.providerType)
  }
  get _hosts() {
    return store.getters.hosts.filter(host => host.provider === this.id)
  }
}

export default D2C_ProviderHosting
